export default "__VITE_ASSET__98b411be__"